export const toolTipCustomStyles = {
  padding: '8px',
  fontStyle: 'normal',
  fontWeight: 400,
  fontSize: '14px',
  alignItems: 'center',
  textAlign: 'center',
  letterSpacing: '0.15px',
  '&.MuiTooltip-tooltip.MuiTooltip-tooltipPlacementBottom': {
    margin: '0',
  },
}
